"use client";

import useSession from "@/hooks/useSession";
import axios from "axios";
import mixpanel from "mixpanel-browser";
import { useParams, useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";
const token = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;
export default function Mixpanel() {
  //default values
  const params = useParams();
  const query = useSearchParams();
  const session = useSession();
  const router = useRouter();
  useEffect(() => {
    // add global axios interceptor
    axios.interceptors.response.use(response => response, error => {
      if (error.response && error.response.status === 403) {
        console.error("Access forbidden: 403");
        router.push("/");
      }
      if (error.response && error.response.status === 401) {
        console.error("Access forbidden: 403");
        router.push("/");
      }
      return Promise.reject(error);
    });
  });
  useEffect(() => {
    if (token) {
      mixpanel.init(token, {
        debug: true,
        track_pageview: true,
        persistence: "localStorage"
      });
    }
  }, []);
  useEffect(() => {
    // if we have any userID, we can identify the user like so
    if (session?.email && token) {
      mixpanel.identify(session.email);
      mixpanel.people.set({
        email: session.email,
        name: session?.email?.split("@")[0].split(".").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
      });
    }
  }, [session?.email]);
  useEffect(() => {
    if (token && mixpanel) {
      // here we can add data that will be sent to mixpanel for every event
      mixpanel.register({
        ...params,
        ...query
      });
    }
  }, [params, query]);
  return null;
}